import SeoHead from '@/components/feature/SeoHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingCTA from '@/components/feature/FloatingCTA';
import HeroSection from './components/HeroSection';
import FeaturedServices from './components/FeaturedServices';
import WhyUsSection from './components/WhyUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import EmergencyBanner from './components/EmergencyBanner';
import MapSection from './components/MapSection';

const SITE = import.meta.env.VITE_SITE_URL || 'https://vanpolattesisat.biz';

const HOME_SCHEMA = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE}/#localbusiness`,
    name: 'Van Polat Tesisat',
    description:
      'Van Polat Tesisat olarak Van genelinde su kaçağı tespiti, tıkanıklık açma, kombi servisi ve tüm tesisat işleri profesyonel ekiplerle yapılır.',
    url: `${SITE}/`,
    telephone: '+905076074165',
    priceRange: '₺₺',
    image: `${SITE}/og-image.jpg`,
    foundingDate: '2009',
    currenciesAccepted: 'TRY',
    paymentAccepted: 'Cash, Credit Card',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Van Merkez',
      addressLocality: 'Van',
      addressRegion: 'Van',
      postalCode: '65000',
      addressCountry: 'TR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 38.4942,
      longitude: 43.3832,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '07:00',
        closes: '22:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '08:00',
        closes: '20:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Sunday',
        opens: '09:00',
        closes: '18:00',
      },
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+905076074165',
        contactType: 'customer service',
        availableLanguage: 'Turkish',
      },
      {
        '@type': 'ContactPoint',
        telephone: '+905438207155',
        contactType: 'customer service',
        availableLanguage: 'Turkish',
      },
      {
        '@type': 'ContactPoint',
        telephone: '+905436412016',
        contactType: 'customer service',
        availableLanguage: 'Turkish',
      },
    ],
    areaServed: {
      '@type': 'City',
      name: 'Van',
      sameAs: 'https://www.wikidata.org/wiki/Q131753',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Tesisat Hizmetleri',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Su Kaçağı Tespiti Van' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tıkanıklık Açma Van' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Kombi Servisi Van' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Doğalgaz İç Tesisat Van' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Petek Temizleme Van' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Yangın Sistemleri Van' } },
      ],
    },
    sameAs: [
      `https://wa.me/905076074165`,
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE}/#website`,
    name: 'Van Polat Tesisat',
    url: `${SITE}/`,
    inLanguage: 'tr-TR',
    publisher: {
      '@id': `${SITE}/#localbusiness`,
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE}/hizmetler`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE}/#webpage`,
    name: 'Van Polat Tesisat | Su Kaçağı Tespiti, Tıkanıklık Açma, Kombi Servisi Van',
    description:
      'Van Polat Tesisat olarak Van genelinde su kaçağı tespiti, tıkanıklık açma, kombi servisi ve tüm tesisat işleri profesyonel ekiplerle yapılır.',
    url: `${SITE}/`,
    inLanguage: 'tr-TR',
    isPartOf: { '@id': `${SITE}/#website` },
    about: { '@id': `${SITE}/#localbusiness` },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: `${SITE}/` },
      ],
    },
  },
];

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <SeoHead
        title="Van Polat Tesisat | Su Kaçağı Tespiti, Tıkanıklık Açma, Kombi Servisi Van"
        description="Van Polat Tesisat olarak Van genelinde su kaçağı tespiti, tıkanıklık açma, kombi servisi ve tüm tesisat işleri profesyonel ekiplerle yapılır. Hızlı servis için hemen arayın."
        keywords="van tesisatçı, van su kaçağı tespiti, van tıkanıklık açma, van kombi servisi, van petek temizleme, van lavabo açma, van kanal açma, van su tesisatı, acil tesisatçı van, en yakın tesisatçı van"
        canonical="/"
        schema={HOME_SCHEMA}
      />
      <Navbar />
      <EmergencyBanner />
      <main className="flex-1 pb-16 md:pb-0">
        <HeroSection />
        <FeaturedServices />
        <WhyUsSection />
        <TestimonialsSection />
        <MapSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
